import Http from './http'

export default {
    // 资源域名
    downPath: '',

    // 登陆
    login: function(params){return Http.post('/wapapi/site/login', params)},
    // 退出登录
    exitLogin: function(params){return Http.post('/wapapi/site/logout', params)},
    // 获取授权登录地址
    getLoginUrl: function(params){return Http.fetch('/wapapi/site/wxloginurl', params)},
    // 授权登录
    wxLogin: function(params){return Http.post('/wapapi/site/wxlogin', params)},
    getShareConfig: function(params){return Http.fetch('/wapapi/base/signpackage', params)},

    // 快速委托/报名
    fastDelegate: function(params){return Http.post('/wapapi/base/fastdelegate', params)},

    // 首页信息
    getHomeInfo: function(params){return Http.fetch('/wapapi/index', params)},

    // 活动城市
    getCityInfo: function(params){return Http.fetch('/wapapi/base/cityinfo', params)},
    // 获取省份列表
    getProvinces: function(params){return Http.fetch('/wapapi/base/province', params)},
    // 获取城市列表
    getCitys: function(id){return Http.fetch('/wapapi/base/citys', {provice_id: id})},
    // 获取区县、地铁列表
    getAreas: function(id){return Http.fetch('/wapapi/base/area', {ciyty_id: id})},
    // 获取地铁站点
    getSteps: function(id){return Http.fetch('/wapapi/base/steps', {line_id: id})},
    // 获取省份城市区域名称
    getAreaName: function(province_id, city_id, area_id){return Http.fetch('/wapapi/base/areaname', {province_id: province_id, city_id: city_id, area_id: area_id})},

    // 产业定位
    getOrderby: function(id){return Http.fetch('/wapapi/base/buildingtesepart', {parent_id: id})},
    // 筛选条件
    getCriteria: function(params){return Http.fetch('/wapapi/base/criteria', params)},

    // 获取楼盘列表信息
    getBuildingList: function(params){return Http.fetch('/wapapi/building/list', params)},
    // 获取楼盘明细
    getBuildingView: function(params){return Http.fetch('/wapapi/building/view', params)},
    // 获取楼盘详情
    getBuildingDetail: function(params){return Http.fetch('/wapapi/building/detail', params)},

    // 获取房源列表信息
    getHouseList: function(params){return Http.fetch('/wapapi/house/list', params)},
    // 获取房源明细
    getHouseView: function(params){return Http.fetch('/wapapi/house/view', params)},
    // 获取房源详情
    getHouseDetail: function(params){return Http.fetch('/wapapi/house/detail', params)},

    // 开发区列表接口
    getDevelopmentList: function(params){return Http.fetch('/wapapi/development/list', params)},
    // 开发区类型列表
    getZoneType: function(params){return Http.fetch('/wapapi/base/zone_type', params)},
    // 开发区详情
    getDevelopmentDetail: function(params){return Http.fetch('/wapapi/development/view', params)},
    // 开发区动态列表
    getDevelopmentView: function(params){return Http.fetch('/wapapi/development/view', params)},

    // 资讯类型
    getArticleType: function(params){return Http.fetch('/wapapi/article/articletype', params)},
    // 资讯列表
    getArticleList: function(params){return Http.fetch('/wapapi/article/list', params)},
    // 资讯详情
    getArticleView: function(params){return Http.fetch('/wapapi/article/view', params)},

    // 经纪人列表
    getAgentList: function(params){return Http.fetch('/wapapi/agent/list', params)},
    // 经纪人详情
    getAgentView: function(params){return Http.fetch('/wapapi/agent/view', params)},
    // 经纪人房源
    getAgentHouseList: function(params){return Http.fetch('/wapapi/house/list', params)},
    // 经纪人攻略
    getAgentStrategyList: function(params){return Http.fetch('/wapapi/strategy/list', params)},
    // 经纪人攻略详情
    getAgentStrategyView: function(params){return Http.fetch('/wapapi/strategy/view', params)},
    // 经纪人问答
    getAgentQuestionList: function(params){return Http.fetch('/wapapi/question/list', params)},

    // 问答列表
    getQuestionList: function(params){return Http.fetch('/wapapi/question/list', params)},
    // 问答详情
    getQuestionView: function(params){return Http.fetch('/wapapi/question/view', params)},
    // 问答回复
    replyQusetion: function(params){return Http.post('/wapapi/question/replyqusetion', params)},
    // 设置为最佳回复
    setBest: function(params){return Http.post('/wapapi/question/usersetbestanswer', params)},

    // 发布委托
    addEntrust: function(params){return Http.post('/wapapi/user/entrust_add', params)},

    // 获取个人中心
    getUserInfo: function(params){return Http.fetch('/wapapi/user/user_info', params)},
    // 关注
    addFocus: function(params){return Http.post('/wapapi/user/addfocus', params)},
    // 取消关注
    delFocus: function(params){return Http.post('/wapapi/user/focus_close', params)},
    // 收藏
    addCollection: function(params){return Http.post('/wapapi/user/addcollection', params)},
    // 取消收藏
    delCollection: function(params){return Http.post('/wapapi/user/collection_close', params)},

    // 委托中心
    getEntrustList: function(params){return Http.post('/wapapi/user/entrust_center_list', params)},
    // 委托中心-查看
    getEntrustView: function(params){return Http.fetch('/wapapi/user/entrust_center_view', params)},
    // 我要投标
    bideUnConfirm: function(params){return Http.fetch('/wapapi/user/bide_unconfirm', params)},
    // 投标房源列表
    bideHouseList: function(params){return Http.fetch('/wapapi/user/house_list', params)},
    // 投标房源信息
    bideHouseView: function(params){return Http.fetch('/wapapi/user/bide_house', params)},
    // 投标确认
    confirmBide: function(params){return Http.post('/wapapi/user/bide_confirm', params)},

    // 编辑个人信息
    editUserInfo: function(params){return Http.post('/wapapi/user/user_info_edit', params)},
    // 发送验证码
    sendMsg: function(params){return Http.post('/wapapi/site/sendmsg', params)},
    // 更换手机号
    saveMobile: function(params){return Http.post('/wapapi/user/save_mobile', params)},
    // 认证效验
    checkCertification: function(params){return Http.fetch('/wapapi/user/check_certification', params)},
    // 认证开发商/经纪人
    checkBorker: function(params){return Http.post('/wapapi/user/authentication_borker', params)},


    // 关注列表
    getFocusList: function(params){return Http.fetch('/wapapi/user/focus_list', params)},
    // 关注列表
    closeFocus: function(params){return Http.post('/wapapi/user/focus_close', params)},

    // 我的楼盘列表
    getUserBuildingList: function(params){return Http.fetch('/wapapi/user/building_list', params)},
    // 我的楼盘列表-删除
    delUserBuilding: function(params){return Http.post('/wapapi/user/delete_building', params)},
    // 我的楼盘列表-放弃
    cancelUserBuilding: function(params){return Http.post('/wapapi/user/abandon_building', params)},

    // 我的房源列表
    getUserHouseList: function(params){return Http.fetch('/wapapi/user/house_list', params)},
    // 我的房源列表-删除
    delUserHouse: function(params){return Http.post('/wapapi/user/delete_house', params)},

    // 我的攻略列表
    getUserStrategyList: function(params){return Http.fetch('/wapapi/user/strategy_list', params)},
    // 我的攻略列表-删除
    delUserStrategy: function(params){return Http.post('/wapapi/user/delete_strategy', params)},

    // 我的投标列表
    getUserBidedList: function(params){return Http.fetch('/wapapi/user/bided_list', params)},
    // 我的投标列表-查看
    viewUserBided: function(params){return Http.fetch('/wapapi/user/viewbided', params)},

    // 我的委托列表
    getUserEntrustList: function(params){return Http.fetch('/wapapi/user/entrust_list', params)},
    // 我的委托列表-查看
    viewUserEntrust: function(params){return Http.fetch('/wapapi/user/entrust_view', params)},
    // 我的委托列表-重启
    againUserEntrust: function(params){return Http.post('/wapapi/user/entrust_again_open', params)},
    // 我的委托列表-反馈
    fbUserEntrust: function(params){return Http.post('/wapapi/user/entrust_add_feedback', params)},
    // 我的委托列表-删除
    delUserEntrust: function(params){return Http.post('/wapapi/user/entrust_delete', params)},

    // 我的预约列表
    getUserAppointList: function(params){return Http.fetch('/wapapi/user/appoint_list', params)},
    // 我的预约列表-查看
    getUserAppointView: function(params){return Http.fetch('/wapapi/user/appoint_view', params)},
    // 我的预约列表-取消
    cancelUserAppoint: function(params){return Http.fetch('/wapapi/user/cancel_appoint', params)},
    // 我的预约列表-取消原因
    cancelLationreason: function(params){return Http.fetch('/wapapi/base/cancellationreason', params)},

    // 我的收藏-资讯
    getcollectionArticle: function(params){return Http.fetch('/wapapi/user/collection_article_list', params)},
    // 我的收藏-楼盘
    getcollectionBuilding: function(params){return Http.fetch('/wapapi/user/collection_building_list', params)},
    // 我的收藏-房源
    getcollectionHouse: function(params){return Http.fetch('/wapapi/user/collection_house_list', params)},
    // 我的收藏-问答
    getcollectionQuestion: function(params){return Http.fetch('/wapapi/user/collection_question_list', params)},


    // 我的问答列表
    getUserQuestionList: function(params){return Http.fetch('/wapapi/user/question_list', params)},
    // 我的问答开启
    openQuestion: function(params){return Http.post('/wapapi/user/question_open', params)},
    // 我的问答关闭
    closeQuestion: function(params){return Http.post('/wapapi/user/question_close', params)},
    // 我的问答删除
    delQuestion: function(params){return Http.post('/wapapi/user/question_close', params)},

    // 消息中心
    getMsgList: function(params){return Http.fetch('/wapapi/user/message_list', params)},
    // 消息中心-删除
    delMsg: function(params){return Http.post('/wapapi/user/message_delete', params)},

    // 搜索
    searchList: function(params){return Http.fetch('/wapapi/search/list', params)},

    //housedesc
    getHouseDesc:function(params){return Http.fetch('/wapapi/building/view', params)},
    //getHousedesc
    getHousedesc:function(params){return Http.fetch('/wapapi/building/detail', params)},
    //new
    getNav:function(params){return Http.fetch('/wapapi/article/newtype', params)},
    getList:function(params){return Http.fetch('/wapapi/article/newlist', params)}
}